import Header, {
  IHeaderProps
} from "components/common/PanelLayout/Header/Header";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import LeftPanel from "components/common/RightLeftLayout/Panels/LeftPanel";
import RightPanel from "components/common/RightLeftLayout/Panels/RightPanel";
import * as React from "react";
import styled from "styled-components";

interface IProps extends IHeaderProps {
  leftPanel: React.ReactNode;
  rightPanel: React.ReactNode;
  whiteRightPanel?: boolean;
  centerRightContent?: boolean;
  centerLeftContent?: boolean;
}

const RightLeftLayout = ({
  title,
  titleSecondary,
  rightTitle,
  leftPanel,
  rightPanel,
  actionComponent,
  infoComponent,
  whiteRightPanel,
  closeButtonHandler = false,
  backButtonHandler,
  centerRightContent,
  centerLeftContent
}: IProps) => (
  <PanelLayout
    title={title}
    titleSecondary={titleSecondary}
    rightTitle={rightTitle}
    backButtonHandler={backButtonHandler}
    closeButtonHandler={closeButtonHandler}
    actionComponent={actionComponent}
    infoComponent={infoComponent}
  >
    <React.Fragment>
      <LeftPanel centerContent={centerLeftContent}>{leftPanel}</LeftPanel>
      <RightPanel centerContent={centerRightContent} white={whiteRightPanel}>
        {rightPanel}
      </RightPanel>
    </React.Fragment>
  </PanelLayout>
);

export default RightLeftLayout;



// WEBPACK FOOTER //
// ./src/components/common/RightLeftLayout/RightLeftLayout.tsx